import React, { useState, useGlobal } from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { STRING_INPUT, CONTENT_BLOCK, TITLE } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, WHITE } from "./baseModal/colours";
import "../../assets/css/componentSpecificCss/checkout.css";

import { ModalTemplate, ModalFields } from "../UI/modalComponents";

const ConfirmExitModal = ({ onClose, onSuccess }) => {
  const [giftNumber, setGiftNumber] = useState("");
  const [loading, setLoading] = useGlobal("loading");

  const getBaseModalFields = () => {
    const descriptionField = {
      type: TITLE,
      data: {
        name: "Are you sure you want to exit? Your progress will not be saved.",
        titleStyle: { fontSize: "1.8rem" }
      }
    };

    const fields = [];

    fields.push(descriptionField);

    return fields;
  };

  const getBaseModalButtons = () => {
    const confirmButton = {
      name: "Confirm",
      buttonColour: WHITE,
      textColour: BLUE_BUTTON,
      handleClick: () => onSuccess()
    };

    const cancelButton = {
      name: "Cancel",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      handleClick: () => onClose()
    };

    return [confirmButton, cancelButton];
  };

  const getBaseModalProps = () => {
    return {
      title: "Exit Checkout",
      fields: getBaseModalFields(),
      buttons: getBaseModalButtons(),
      handleClose: onClose,
      height: "auto",
      midSectionHeight: "auto"
    };
  };

  return <BaseModal {...getBaseModalProps()} />;
};

export default withRouter(ConfirmExitModal);
